import AppRouter from './routes/AppRouter'
import { Toaster } from 'sileo'

/**
 * Componente raíz de la aplicación.
 * * Este componente define la estructura base del DOM, configura el proveedor
 * de notificaciones global (Toaster) con soporte para diseño responsivo y
 * modo oscuro, y renderiza el enrutador principal.
 * * @component
 * @returns {JSX.Element} El contenedor principal de la aplicación.
 */
function App() {
  return (
    <div className="min-vh-100 bg-body text-body">
      {/* Configuración Responsive para el Toaster:
          1. Z-Index alto para que no lo tapen los Modales.
          2. El contenedor se adapta al tema (dark/light) de Bootstrap.
      */}
      <div style={{ zIndex: 10000 }}>
        <Toaster
          position="bottom-right"
          // Ajuste responsive mediante CSS in JS o clases
          toastOptions={{
            // Estilos que responden al modo oscuro de Bootstrap
            className: 'shadow-lg border-0',
            style: {
              borderRadius: '12px',
              padding: '16px',
              fontSize: '14px',
              // Esto hace que en pantallas pequeñas sea más manejable
              maxWidth: '90vw',
            },
          }}
        />
      </div>

      <AppRouter />

      <style>{`
        /* Media query para hacer el Toaster full-width en móviles */
        @media (max-width: 576px) {
          .sileo-toaster-container {
             left: 10px !important;
             right: 10px !important;
             bottom: 10px !important;
          }
          .sileo-toast {
            width: 100% !important;
          }
        }

        /* Soporte para modo oscuro automático si la librería no lo trae */
        [data-theme='dark'] .sileo-toast {
          background-color: var(--bg-surface) !important;
          color: var(--text) !important;
          border: 1px solid var(--border) !important;
        }
      `}</style>
    </div>
  )
}

export default App
